import React from 'react';
import './CheckboxWithLink.css';

const CheckboxWithLink = ({ checked, onChange, linkText, onClickLink, labelText }) => {
  return (
    <div className="form-group checkbox-container">
      <input
        type="checkbox"
        id="termsAccepted"
        checked={checked}
        onChange={onChange}
      />
      <label htmlFor="termsAccepted">
        {labelText} <a href="#" onClick={onClickLink}>{linkText}</a>
      </label>
    </div>
  );
};

export default CheckboxWithLink;
